import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // LocalStorage'dan tema tercihini oku
    const saved = localStorage.getItem('helpdesk_theme');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    // Tema değiştiğinde LocalStorage'a kaydet
    localStorage.setItem('helpdesk_theme', JSON.stringify(isDarkMode));
    
    // HTML root element'ine class ekle/çıkar
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const value = {
    isDarkMode,
    toggleTheme,
    theme: isDarkMode ? 'dark' : 'light'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};